<template>
  <div id="appNav">
      <nav class="navbar navbar-expand-lg bgColor" :style="variables">
            <a class="navbar-brand" href="#home">
               
                    <img  src="../assets/logo_white.png"  height="30" alt="" loading="lazy">
            </a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <i class="fa fa-bars"></i>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item active">
                <a class="nav-link" href="#home">HOME
                    <span class="sr-only">(current)</span></a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="/#projects">PROJECT</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href='/#resource-partners'> RESOURCE PARTNERS</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="/#signUp">SIGN UP</a>
                </li>
            </ul>
            </div>
        </nav>
    </div>
</template>

<script>
import $ from 'jquery'
$(window).scroll(function() {
    $('nav').toggleClass('scrolled',$(this).scrollTop() > 0)
})
export default {
props:['bgColor', 'textColor', 'from'],

computed:{
variables() {
    return {
        '--bg-color':this.bgColor,
         '--text-color':this.textColor,
         '--position':this.from === 'home' ? '': 'fixed'
    }
}
},

}
</script>

<style scoped>

.bgColor.scrolled{
    background-color: rgb(25,22,51);
}
nav{
    /* background-color: rgb(25,22,51); */
    width:100%;
    height: 59px;
    top:0;
    z-index: 10;
    position: fixed;
}
.navbar-nav li{
  padding:0 10px;
}
.navbar-nav li a {
  font-weight: 600;
  float:right;
  text-align: left;
  color:var(--text-color) !important;
}

.fa-bars{
  color:var(--text-color);
  font-size: 30px !important;
}
.navbar-toggler{
  outline:none;
}
@media screen and (max-width: 992px) {
    .navbar-collapse{
        background-color: black;
        width:100%;
        padding:30px;
        color:red !important;
        }
}
</style>